import React from 'react';

import Box from '~/ui/components/Box/Box';
import Button from '~/ui/components/Button/Button';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import styles from '~/ui/styles';

function Footer({ leftAction, rightAction }) {
  return (
    <Box
      bg="white"
      sx={{
        borderTop: 'border',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <FlexLayout
        justifyContent="space-between"
        mx="auto"
        py={6}
        sx={styles.layout.container}
      >
        {leftAction && <Button {...leftAction} variant="outlined" />}
        {rightAction && <Button {...rightAction} />}
      </FlexLayout>
    </Box>
  );
}

export default Footer;
